import React from "react";
import AddressLookup from "./AddressLookup";
import { BrandButton } from "../assets";
import { useSelector, useDispatch } from "react-redux";
import { addressToString } from "../helpers";
import { changeAddresses } from "../actions/session";
import { useModal } from "../assets/useModal";

export default function AddressSelector({ onChange, currentAddress, origin }) {

	const serializedCurrentAddress = currentAddress ? serialize(currentAddress) : null;
	const { setModal, openModal, closeModal } = useModal();

	const dispatch = useDispatch();
	const {
		user
	} = useSelector(state => ({
		user: state.session.user
	}));

	function openSearcher() {
		setModal(<section key={Math.random()}>
			<h4>Add a new address</h4>
			<div style={{ padding: 20 }}>
				<div>
					Try searching for your address in plain text <i>"16 London Road"</i>, or if you're trying to find a business address, you can search for the business name <i>"Epic Cakes Ltd"</i>.
					<br /><br />
				</div>
				<AddressLookup
					origin={origin ? `${origin.lat},${origin.lng}` : undefined}
					onChange={address => {
						let sanitized = sanitize(address);
						dispatch(changeAddresses([...user.addresses, sanitized]));
						onChange(sanitized);
						closeModal();
					}}
				/>
			</div>
			<br /><br />
		</section>);
		openModal();
	}

	return <div className="addressSelector">
		{Boolean(user.addresses.length) && <div>
			{user.addresses.map(address => {

				const stringed = addressToString(address);
				const serializedAddress = serialize(address);
				const isCurrent = serializedAddress === serializedCurrentAddress;

				return <div
					className={`address-item ${isCurrent ? "current" : ""}`}
					key={stringed}
					style={{
						cursor: isCurrent ? "default" : "pointer"
					}}
					onClick={e => {
						if (isCurrent) return;
						onChange(sanitize(address));
					}}
				>
					<span>{stringed}</span>
					{!isCurrent && <span className="remove" onClick={e => {
						e.stopPropagation();
						if (window.confirm("Are you sure you want to remove this address?"))
							dispatch(changeAddresses(user.addresses.filter(a => serialize(a) !== serializedAddress)));
					}}>x</span>}
				</div>
			})}
		</div>}
		<BrandButton onClick={openSearcher}>Add a new address</BrandButton>
	</div>
}

function sanitize(address) {
	return address ? {
		line1: address.line1,
		line2: address.line2,
		town: address.town,
		postCode: address.postCode,
		location: address.location || undefined,
		mapLink: address.mapLink || undefined
	} : null;
}

function serialize(address) {
	return `${address.line1}_${address.postCode}`;
}